import { Component } from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {IconsService} from "../../services/icons.service";
import {ChatsService} from "../../services/chats.service";
import {Clipboard, ClipboardModule} from "@angular/cdk/clipboard";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {interfaceActions} from "../../state/interface/interface.actions";

@Component({
  selector: 'context-new-selector',
  standalone: true,
  imports: [
    FaIconComponent,
    ClipboardModule
  ],
  templateUrl: './context-new-selector.component.html',
  styleUrl: './context-new-selector.component.scss'
})
export class ContextNewSelectorComponent {
  constructor(
      private store: Store,
      private route: ActivatedRoute,
      private fileService: FilesService,
      protected iconsService: IconsService,
      private chatService: ChatsService,
      private router: Router,
      private clipboard: Clipboard
  ) {
    this.route.queryParams.subscribe(params => {
    });
  }
  async closeContextMenu() {
    await this.router.navigate( [{outlets: {'context-menu': null}}], { queryParamsHandling: 'preserve' })
    this.store.dispatch(interfaceActions.closeContextMenu())
  }

  newMedia(){
    this.closeContextMenu()
    this.router.navigate([{outlets: {'new-modal-pane': "new-images"}}])
  }
  newPost() {
    this.closeContextMenu()
    this.router.navigate([{outlets: {'new-modal-pane': "new-flyer"}}])
  }

  newMapReaction() {
    this.closeContextMenu()
    this.router.navigate([{outlets: {'new-modal-pane': "new-map-reaction"}}])
  }
}
